import React, { useEffect, useState } from 'react'

interface DraggableProps {
    children: React.ReactNode;
    onDragEnd: (itemList: any) => void;
    // ... other props ...
  }

export const Draggable: React.FC<DraggableProps> = ({ children, onDragEnd }) => {
    const [listItems, setListItems] = useState(React.Children.toArray(children))
    const [draggedListItem, setDraggedListItem] = useState(null)

    useEffect(() => {
        setListItems(React.Children.toArray(children))
    },[children])

    const handleDragStart = (e, index) => {
       setTimeout(() => {
            setDraggedListItem(index)
        })
        e.dataTransfer.setData('index', index)
    }

    const handleDragOver = (e, index) => {
        e.preventDefault()
        if (draggedListItem !== index) {
            const newData = [...listItems]
            const [removedItem] = newData.splice(draggedListItem, 1)
            newData.splice(index, 0, removedItem)
            setListItems(newData)
            setDraggedListItem(index)
        }
    }

    const handleDragEnd = (e) => {
        const newData = [...listItems]
        const updatedList = newData.map((data) => {
            return `${(data as {key:string})?.key}`.replace(/^\.\$/, '')
        })
        onDragEnd && onDragEnd(updatedList);
        setDraggedListItem(null)
    }


    return (
        <ul className={'list-none flex flex-col gap-3 p-0 m-0'}>
            {React.Children.map(children, (item, index) => { 
            return (
                <li
                    key={index}
                    className={`form-inputs width-30 border-1 border-grey bora-2 margin-b15 cursor-grab  ${draggedListItem === index && 'opacity-0'}`}
                    draggable
                    onDragStart={(e) => handleDragStart(e, index)}
                    onDragOver={(e) => handleDragOver(e, index)}
                    onDragEnd={(e) => handleDragEnd(e)}
                >
                    {item}
                </li>
            )})}
        </ul>
    )
}
